import { render, staticRenderFns } from "./teamValue.vue?vue&type=template&id=0d9619f7&"
import script from "./teamValue.vue?vue&type=script&lang=js&"
export * from "./teamValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports